import type { FaireProductEntity } from "../../entity_types/product";

export const p_vzmvedpg94: FaireProductEntity = {
  token: "p_vzmvedpg94",
  type: "product",
  name: "Pebble Speckled Beanie – Cozy & Stylish for Cold Weather",
  brandToken: "b_32rsz10vd0",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/da2c1d4d5e47d3bcd8429de1e05864c7d7756ddcc2265901faa989914d509387.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1c4610fa35ce23eaeec29de5db3eee40c804b88888908c66b0b9f0c83f58d898.png",
    "https://cdn.faire.com/fastly/2d185d495cab5f461359aad4418ac53268c0757b670f7e9e11237afc870fdb0a.jpeg",
    "https://cdn.faire.com/fastly/d43f33a385bf254e75a3894abfca4d876d3662cb61456a253da210be777b7b7c.jpeg",
    "https://cdn.faire.com/fastly/b753ec853b4954409d055f2d4bfa0a8945103d38cfee72b17cbfd30cc4a483b4.jpeg",
    "https://cdn.faire.com/fastly/e5c0cd271f8938459c5a0f8c97be70e72fb15ed2d303cb5ed30c662cbd8d121e.jpeg",
    "https://cdn.faire.com/fastly/cee714e467cd4972380f4a3c72ce8f9e6c69a759967eb42104146ef5fe118a45.jpeg",
    "https://cdn.faire.com/fastly/04859c25ad4a10cf298ed2408b74de7cb92785da3dfe478ca212c42ac3675f2d.jpeg",
    "https://cdn.faire.com/fastly/76edd72b5f7e056831d2e710cc9b1782c949a53f2955d004ab9c9285438ce2cc.jpeg",
    "https://cdn.faire.com/fastly/513f6fb594b289d24798a04d944c9b28b8ef02f1cec7c8181c31cfaa37485f1b.jpeg",
  ],
  priceDollars: 12.5,
  description:
    "🧣 Stay warm and effortlessly stylish with our Pebble Speckled Beanie! Designed for ultimate comfort and versatility, this oversized knit beanie is crafted from soft, insulating materials to keep you cozy during crisp autumn days and chilly winter nights. Featuring a flattering base color accented with playful speckled hues, it adds texture and charm to any outfit.\n\nWhy You’ll Love It:\n🧶 Soft & Warm Fabric – Perfect for cold-weather layering\n🌈 Playful Speckled Design – Subtle pops of color for added style\n🧢 Oversized Fit – Offers a relaxed, comfy feel for all-day wear\n✨ Versatile & Unisex – Pairs effortlessly with casual and dressed-up looks\n🎁 Great Gift Idea – A must-have winter accessory for friends & family\n\n🖤 Available in multiple colors to match any wardrobe!\n\n🧣✨ Stay cozy in style—shop the Pebble Speckled Beanie now! ✨🧣\n",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:46.319Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
